import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { XCircle, ArrowLeft, CreditCard } from "lucide-react";

const BillingCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 rounded-full bg-[#262626] flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-8 h-8 text-text-muted" />
        </div>
        <h1 className="font-heading text-2xl font-bold text-white mb-2">Checkout canceled</h1>
        <p className="text-text-muted mb-8">
          No worries! You can subscribe anytime when you're ready.
        </p>
        
        <Card className="bg-surface border-[#262626] mb-6">
          <CardContent className="pt-6">
            <div className="space-y-4">
              <Button
                onClick={() => navigate('/dashboard')}
                className="w-full bg-[#D4F34A] text-black hover:bg-[#D4F34A]/90 font-bold py-6"
              >
                <ArrowLeft className="w-4 h-4 mr-2" /> Back to Dashboard
              </Button>
              <Button
                onClick={() => navigate('/dashboard')}
                variant="outline"
                className="w-full border-[#262626] hover:bg-[#1E1E1E] py-6"
              >
                <CreditCard className="w-4 h-4 mr-2" /> Try Again
              </Button>
            </div>
          </CardContent>
        </Card>
        
        <p className="text-xs text-text-muted">
          Questions? Contact us at hello@replydriven.com
        </p>
      </div>
    </div>
  );
};

export default BillingCancel;
